/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable key-spacing */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import CheckBoxTree from "./CheckboxTree";
import ConfigContext from "./context";

const TreeNode = ({ path, name, checked, isOpen, children, ...restData }) => {
	const nodeData = {
		path,
		name,
		checked,
		isOpen,
		...restData,
	};

	const { handleCheck, handleToggleOpen, onNameClick, showCheckbox, readOnly } =
		useContext(ConfigContext);

	const isFolder = children?.length > 0;

	const handleCheckBoxChange = e => {
		if (readOnly) return;

		const newStatus = +e.target.checked;
		handleCheck(path, newStatus);
	};

	const selectMe = () => !readOnly;
	const openMe = () => handleToggleOpen(path, true);
	const closeMe = () => handleToggleOpen(path, false);

	const handleNameClick = () => {
		const defaultOnClick = selectMe;
		if (onNameClick && typeof onNameClick === "function") {
			onNameClick({ defaultOnClick, nodeData });
		} else {
			defaultOnClick();
		}
	};

	const folderCaret = (
		<span>
			<If condition={isOpen}>
				<i
					className="glyphicon glyphicon-triangle-bottom"
					onClick={closeMe}
				/>
			</If>

			<If condition={!isOpen}>
				<i
					className="glyphicon glyphicon-triangle-top"
					onClick={openMe}
				/>
			</If>
		</span>
	);

	return (
		<li className={classNames("wrapper-node", { "child-item": !isFolder })}>
			<div className={classNames("tree-node")}>
				<If condition={showCheckbox}>
					<CheckBoxTree
						status={checked}
						onChange={handleCheckBoxChange}
					/>
				</If>

				{isFolder && folderCaret}

				<span
					onClick={handleNameClick}
					title={name}
				>
					{name}
				</span>
			</div>

			<ul>
				<If condition={isFolder && isOpen}>
					<For
						each="data"
						index="idx"
						of={children}
					>
						<TreeNode
							key={data._id}
							path={[...path, Number(idx)]}
							{...data}
						/>
					</For>
				</If>
			</ul>
		</li>
	);
};

TreeNode.propTypes = {
	path: PropTypes.array.isRequired,
	name: PropTypes.string.isRequired,
	checked: PropTypes.number.isRequired,
	isOpen: PropTypes.bool,
	children: PropTypes.array,
};

TreeNode.defaultProps = {
	isOpen: false,
	children: [],
};

export default TreeNode;
